import React, { useState } from 'react'
import Add from './add'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
// import { consoleLog } from '../../../../util'
import { Wrapper } from './style'

const ManageSubKeywords = () => {
  const [updatedData, setUpdatedData] = useState(0)

  const updatedDataFunc = (obj = {}) => {
    setUpdatedData(updatedData + 1)
  }

  return (
    <Wrapper>
        <AccordionWithArrow title='Manage Sub Keywords' expanded={true} accordionstyle='fieldset'>
            <Add onChange={updatedDataFunc} />
            <Grid refreshData={updatedData} />
        </AccordionWithArrow>
    </Wrapper>
  )
}

export default ManageSubKeywords
